import {FC, ReactNode, useRef} from 'react';
import {useTableHeaderRow} from 'react-aria';
import {Node, TableState} from 'react-stately';
import TableStaticHeaderRow from 'components/Table/TableStatic/TableStaticHeaderRow';

type TableHeaderRowProps = {
    children: ReactNode;
    item: Node<unknown>;
    state: TableState<unknown>;
};

const TableHeaderRow: FC<TableHeaderRowProps> = ({children, item, state}) => {
    const ref = useRef(null);
    const {rowProps} = useTableHeaderRow({node: item}, state, ref);

    return (
        <TableStaticHeaderRow {...rowProps} ref={ref}>
            {children}
        </TableStaticHeaderRow>
    );
};

export default TableHeaderRow;
